import { TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { HelpService } from '~commonInfra/services/HelpService';
import { Messages } from '~src/codegen/Localize';
import { learnMoreStyle } from '~src/settings/styles/CommonStyles';

export function DataConnectNetworkAllowlistInformation() {
    return (
        <span>
            {Messages.dataConnectSiteSettingsAllowlistRegistryInfo()}
            <TextLinkWidget
                className={learnMoreStyle}
                href={HelpService.getServerHelpUrlByCategory('server-DataConnect-registry')}
                target='_blank'
                testId={'learn-more'}
            >
                {Messages.learnMore()}
            </TextLinkWidget>
        </span>
    );
}
